import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Comparable from './Comparable'
import styles from './styles.scss'

class Comparables extends Component {
  _renderComparables = () => {
    const { campaignComparables, brand } = this.props
    const count = campaignComparables.length

    if (!count){
      return <div>Nothing to see...</div>
    }

    return campaignComparables.map((comparable, index) => {
      const showLarge = index === 0
      return <Comparable key={comparable.id} campaignComparable={comparable} brand={brand} large={showLarge} />
    })
  }

  render(){
    return <div className={styles.root}>{this._renderComparables()}</div>
  }
}

Comparables.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignComparables: PropTypes.array.isRequired,
}

export default Comparables
